module.exports = __webpack_public_path__ + "img/team_img.83ac0367.png";